<template>
  <div class="landing-page">
    <video autoplay muted loop id="myVideo" playsinline>
      <source src="@/assets/home.mp4" type="video/mp4">
    </video>
  </div>
</template>